<template>
    <b-modal id="contactContractorModal" centered modal-class="modal-garden-help modal-confirm-message" title="Contact Pro"
        title-class="modal-title-garden-help">
        <div class="d-block ">
            <input id="client" name="client" type="hidden" v-model="client_name" />

            <b-row class="">
                <b-col cols="12">
                    <b-form-group class="form-group-garden-help my-0 pb-0" label="Name:" label-for="name" 
                        label-class="form-label-garden-help d-inline" label-cols-sm="3" label-cols-lg="2"
                        content-cols-sm="9" content-cols-lg="9">
                        <span class="form-control form-control-garden-help">
                            {{ operator_data ? operator_data.name : "" }}
                        </span>
                    </b-form-group>
                </b-col>
                <b-col cols="12">
                    <b-form-group class="form-group-garden-help  my-0 pb-0" label="Email:" label-for="email" 
                        label-class="form-label-garden-help d-inline" label-cols-sm="3" label-cols-lg="2"
                        content-cols-sm="9" content-cols-lg="9">
                        <span class="form-control form-control-garden-help" v-if="operator_data">
                            <a :href="'mailto: ' + operator_data.email">{{ operator_data.email  }}</a>
                        </span>
                    </b-form-group>
                </b-col>
                <b-col cols="12">
                    <b-form-group class="form-group-garden-help  my-0 pb-0" label="Phone" label-for="phone" 
                        label-class="form-label-garden-help d-inline" label-cols-sm="3" label-cols-lg="2"
                        content-cols-sm="9" content-cols-lg="9">
                        <span class="form-control form-control-garden-help" v-if="operator_data">
                            <a :href="'tel: ' + operator_data.phone">{{ operator_data.phone  }}</a>
                        </span>
                    </b-form-group>
                </b-col></b-row>
        </div>

        <template class="justify-content-center mt-5" #modal-footer>
            <b-row class="justify-content-center w-100 m-0">

                <b-col xl="4" lg="5" md="6" class="text-center">
                    <b-button type="button" variant="garden-help-primary" class="btn-bumblebee btn-garden-help mb-1 w-100"
                        @click="closeModalCancel">
                        Ok
                    </b-button>
                </b-col>


            </b-row>
        </template>
    </b-modal>
</template>
<script>
import $ from "jquery";
import axios from "axios";

import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";

export default {
    name: "ContactContractor",
    components: { DatePicker },
    props: ["client_name", "operator_data"],
    data() {
        return {
        };
    },
    watch: {
    },
    mounted() {
    },

    methods: {


        closeModalCancel() {
            this.$bvModal.hide("contactContractorModal");
        },
    },
};
</script>
      


// WEBPACK FOOTER //
// src/projects/garden_help/jobs/modal_actions/ContactContractor.vue